<span class="pill"> <ng-content></ng-content> {{ value }} </span>
